import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import FlatButton from '../../components/buttons/flat_button'
import AuthLayout from '../../components/layouts/auth_layout'
import MainBackground from '../../images/main_bg.png'

const PasswordResetSendPage: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { email } = location.state

  return (
    <AuthLayout>
      <div
        className="min-h-screen flex flex-col justify-center items-center bg-cover bg-center bg-no-repeat p-4"
        style={{
          backgroundImage: `url(${MainBackground})`,
        }}
      >
        <div className="w-full overflow-auto py-24 px-4">
          <div className="bg-white rounded-xl w-full max-w-xl mx-auto p-6">
            <h1 className="text-2xl font-bold mb-8 text-center">
              メール送信完了
            </h1>
            <p>{email} 宛にメールを送信しました。</p>
            <p className="mb-8">メールボックスよりご確認ください。</p>
            <FlatButton onClick={() => navigate('/login')} className="w-full">
              ログインページへ戻る
            </FlatButton>
          </div>
        </div>
      </div>
    </AuthLayout>
  )
}

export default PasswordResetSendPage
